export const FILTER_BY_CATEGORY = "FILTER_BY_CATEGORY";
export const FILTER_BY_FLOOR = "FILTER_BY_FLOOR";
export const FILTER_BY_NAME = "FILTER_BY_NAME";
export const CLEAR_FILTER_FLOOR = "CLEAR_FILTER_FLOOR";
export const CLEAR_ALL_FILTER = "CLEAR_ALL_FILTER";
export const FILTER_BY_FLOOR_FROM_HOME = 'FILTER_BY_FLOOR_FROM_HOME'

export const SET_LANGUAGE = 'SET_LANGUAGE';

export const SET_SCREENSAVER_TIME = 'SET_SCREENSAVER_TIME';
export const SET_START_SCREEN = 'SET_START_SCREEN';
export const SET_DEVICE_FLOOR_LEVEL = 'SET_DEVICE_FLOOR_LEVEL';

export const SET_LIST_OF_CODES = 'SET_LIST_OF_CODES';

export const SET_SCREENSAVER = 'SET_SCREENSAVER';

export const SET_MALL_ENVIROMENT_DATA = 'SET_MALL_ENVIROMENT_DATA';
export const SET_MALL_ENVIROMENT_FIRST_LOADING = 'SET_MALL_ENVIROMENT_FIRST_LOADING';

export const SET_FACILITIES = 'SET_FACILITIES';